import React from 'react'

const Categories = () => {
  return (
    <div className='pt-24 md:pt-48 mb-20'>
      <div className='grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-y-5 gap-x-5'>
        <div className='relative shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105 md:max-w-sm h-72 overflow-hidden bg-red-500 min-w-96 bg-category-1 bg-no-repeat bg-cover'>
          <div className='absolute top-40'>
            <h2 className='text-gray-50 text-2xl font-bold ml-2'>Tablet</h2>
            <h2 className='text-gray-50 text-2xl font-bold ml-2'>Collections</h2>
            <h2 className='text-gray-200 mt-3 cursor-pointer font-bold ml-3 animate-bounce'>
              Shop Now
              <i className='fa fa-shopping-cart ml-2'></i>
            </h2>
          </div>
          <div
            style={{
              width: '0',
              height: '0',
              borderTop: '300px solid transparent',
              borderBottom: '300px solid transparent',

              borderLeft: '300px solid #8B0000'
            }}
            className='opacity-100'
          ></div>
        </div>
        <div className='relative shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105 md:max-w-sm h-72 overflow-hidden bg-red-500 min-w-96 bg-category-2 bg-no-repeat bg-cover'>
          <div className='absolute top-40'>
            <h2 className='text-gray-50 text-2xl font-bold ml-2'>Smartphone</h2>
            <h2 className='text-gray-50 text-2xl font-bold ml-2'>Collections</h2>
            <h2 className='text-gray-200 mt-3 cursor-pointer font-bold ml-3 animate-bounce'>
              Shop Now
              <i className='fa fa-shopping-cart ml-2'></i>
            </h2>
          </div>
          <div
            style={{
              width: '0',
              height: '0',
              borderTop: '300px solid transparent',
              borderBottom: '300px solid transparent',

              borderLeft: '300px solid #8B0000'
            }}
            className='opacity-100'
          ></div>
        </div>
        <div className='relative shadow-lg hover:shadow-xl transition-all duration-500 hover:scale-105 md:max-w-sm h-72 overflow-hidden bg-red-500 min-w-96 bg-category-3 bg-no-repeat bg-cover'>
          <div className='absolute top-40'>
            <h2 className='text-gray-50 text-2xl font-bold ml-2'>Accessories</h2>
            <h2 className='text-gray-50 text-2xl font-bold ml-2'>Collections</h2>
            <h2 className='text-gray-200 mt-3 cursor-pointer font-bold ml-3 animate-bounce'>
              Shop Now
              <i className='fa fa-shopping-cart ml-2'></i>
            </h2>
          </div>
          <div
            style={{
              width: '0',
              height: '0',
              borderTop: '300px solid transparent',
              borderBottom: '300px solid transparent',

              borderLeft: '300px solid #8B0000'
            }}
            className='opacity-100'
          ></div>
        </div>
      </div>
    </div>
  )
}

export default Categories
